module.exports = __webpack_public_path__ + "img/pdfestados_pages-to-jpg-aprobada.7a5b0cb2.jpg";